<template>
    <header class="app">
        <div
        class="store-logo-container flex justify-center items-center p-2"
        >
        <NavigationStoreLogo />
        </div>
    </header>
</template>